import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowsRepeatRightLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowsRepeatRightLeft"><Path d="M21.3108 5.75011L17.2501 1.68945L16.1895 2.75011L18.4393 5H3V11H4.5V6.5H18.4396L16.1895 8.75011L17.2501 9.81077L21.3108 5.75011Z" fill="currentColor"/><Path d="M7.81077 15.2501L5.56089 17.5H19.5V12.5H21V19H5.56066L7.81077 21.2501L6.75011 22.3108L2.68945 18.2501L6.75011 14.1895L7.81077 15.2501Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowsRepeatRightLeft;
